import {RefundsApiBase} from './paymentApi';

class RefundsApi extends RefundsApiBase {
}

export default new RefundsApi();
